import { forwardRef } from "react";

import { cn } from "@/lib/utils";

export const Column = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("flex flex-col", className)} {...props}>
      {children}
    </div>
  );
});

Column.displayName = "Column";
